<div class="directions-options">
  <mat-slide-toggle
    [checked]="directionControlIsActive"
    [labelPosition]="'before'"
    (change)="onToggleDirectionsControl($event.checked)"
  >
    {{ 'igo.geo.directions.toggle.activateControl' | translate }}
  </mat-slide-toggle>
</div>

<igo-directions-inputs
  (stopInputHasFocus)="onStopInputHasFocusChange($event)"
  [coordRoundedDecimals]="coordRoundedDecimals()"
  [projection]="projection"
  [stopsFeatureStore]="stopsFeatureStore()"
  [stopsStore]="stopsStore()"
  [debounce]="debounce()"
  [length]="length()"
/>

@if (routesFeatureStore().all().length > 0) {
  <igo-directions-buttons
    [stepsFeatureStore]="stepsFeatureStore()"
    [contextUri]="contextUri()"
    (zoomOnActiveRoute)="zoomOnActiveRoute()"
    [routesFeatureStore]="routesFeatureStore()"
    [stopsStore]="stopsStore()"
  />
}

<igo-directions-results
  [stepsFeatureStore]="stepsFeatureStore()"
  [routesFeatureStore]="routesFeatureStore()"
/>
